var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { computed, makeObservable } from 'mobx';
import { sortedSet } from '../../../../utils/mobx/decorators/customComputed';
import { mergeJsxObjects } from '../component/AspectJsx';
import { AspectBackgroundVideoIntent_ } from '../../../../packages/Rare/components/AspectBackgroundVideoIntent_';
import { InputMask_ } from '../../../../packages/Rare/areas/InputMask/components/InputMask_';
export class AspectMountComponent {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get aspectMount() {
        return this.parent;
    }
    get aspect() {
        return this.aspectMount.parent;
    }
    get Aspect__() {
        return this.aspectMount.Aspect__;
    }
    get ref() {
        // @ts-ignore
        if (this.Aspect__.props.templateComponent && this.Aspect__.props.templateComponent.ref) {
            // @ts-ignore
            return this.Aspect__.props.templateComponent.ref;
        }
        return React.createRef();
    }
    get JsxComponentTag() {
        return this.aspect.aspectJsx.jsxComponentType(this.Aspect__.props.templateComponent);
    }
    get isTagThatCannotHaveChildren() {
        return ['img', 'input'].includes(this.JsxComponentTag);
    }
    get aspectChildren() {
        if (this.isTagThatCannotHaveChildren)
            return undefined;
        let aspectChildren = [
            ...React.Children.toArray(this.Aspect__.props.children),
            ...this.aspect.aspectJsx.jsxChildren_fromTraits,
        ];
        if (!this.isTagThatCannotHaveChildren && this.aspect.valueOf.wrapChildren) {
            aspectChildren = this.aspect.aspectWrap.wrapChildren(aspectChildren);
        }
        /*
        if (Array.isArray(aspectChildren) && aspectChildren.length === 1) {
          aspectChildren = aspectChildren[0];
        }*/
        if (!Array.isArray(aspectChildren)) {
            aspectChildren = [aspectChildren];
        }
        const { renderedIntents } = this.aspect.aspectBackgroundVideo;
        if (renderedIntents.length > 0) {
            aspectChildren.unshift(...this.aspect.aspectBackgroundVideo.renderedIntents.map(videoIntent => (React.createElement(AspectBackgroundVideoIntent_, { aspect: this.aspect, intent: videoIntent, key: videoIntent.id }))));
        }
        /*
          return aspectChildren.sort((child1, child2) => {
              return ('' + child1.key).localeCompare(child2.key);
          });
    */
        return aspectChildren;
        /*
        return aspectChildren.sort((child1, child2) => {
          return ('' + child1.key).localeCompare(child2.key);
        });*/
    }
    get jsxAttributes() {
        const { templateComponent, overwriteComponent } = this.Aspect__.props;
        const { children: removeChildren1, ...jsxAttributesFromTemplateComponent } = (templateComponent && templateComponent.props) || {};
        const { children: removeChildren2, ...jsxAttributesFromOverwriteComponent } = (overwriteComponent && templateComponent.props) || {};
        return mergeJsxObjects({}, jsxAttributesFromTemplateComponent, this.aspect.aspectJsx.jsxAttributes, jsxAttributesFromOverwriteComponent);
    }
    get jsxAttributesFiltered() {
        const { onHoverTime, onTraitBecomeActive, onOptionWasSelected, ...nativeJsxAttributes } = this.jsxAttributes;
        return nativeJsxAttributes;
    }
    get aspectComponent() {
        const JsxComponentTag = this.JsxComponentTag;
        if (JsxComponentTag === 'input') {
            if (this.aspect.context.wordTask && this.aspect.context.wordTask.wordTaskMask.activeInputMask.length > 0) {
                return React.createElement(InputMask_, { aspect: this.aspect, jsxAttributes: this.jsxAttributes });
            }
        }
        // @ts-ignore
        return React.createElement(JsxComponentTag, { ref: this.ref, ...this.jsxAttributesFiltered, children: this.aspectChildren });
    }
}
__decorate([
    computed
], AspectMountComponent.prototype, "ref", null);
__decorate([
    computed
], AspectMountComponent.prototype, "JsxComponentTag", null);
__decorate([
    sortedSet
], AspectMountComponent.prototype, "aspectChildren", null);
__decorate([
    computed.struct
], AspectMountComponent.prototype, "jsxAttributes", null);
__decorate([
    computed
], AspectMountComponent.prototype, "aspectComponent", null);
